import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from "../../../blocks/PageMenu/PageMenu";
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';
import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import useGetInfoSolicitudPagoDirecto from "services/record/SolicitudPagoDirecto/useGetInfoSolicitudPagoDirecto";
import useGetSolicitudPagoDirectoByID from "services/record/SolicitudPagoDirecto/useGetSolicitudPagoDirectoByID";
import useGetSolicitudPagoDirectoByUser from "services/record/SolicitudPagoDirecto/useGetSolicitudPagoDirectoByUser";
import SolicitudPagoDirecto from "./SolicitudPagoDirecto";

const GridSolicitudPagoDirecto = ({ expedienteId = null, origen = null }) => {

    const {
        getSolicitudPagoDirectoByID,
        loadingGetSolicitudPagoDirectoByID,
        statusGetSolicitudPagoDirectoByID
    } = useGetSolicitudPagoDirectoByID();

    const {
        getInfoSolicitudPagoDirecto,
        loadingGetInfoSolicitudPagoDirecto,
        statusGetInfoSolicitudPagoDirecto
    } = useGetInfoSolicitudPagoDirecto();

    const {
        dataGetSolicitudPagoDirectoByUser,
        getSolicitudPagoDirectoByUser,
        loadingGetSolicitudPagoDirectoByUser,
        statusGetSolicitudPagoDirectoByUser
    } = useGetSolicitudPagoDirectoByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Solicitud de Pago Directo Incapacidad Temporal";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    ////////////////////////////////////////
    // Carga inicial
    ////////////////////////////////////////
    useEffect(() => {
        getSolicitudPagoDirectoByUser(userId, expedienteIdByOrigen);
    }, []);

    ////////////////////////////////////////
    // Unificación HTTP
    ////////////////////////////////////////
    useEffect(() => {
        if (statusGetSolicitudPagoDirectoByID?.status) {
            setCurrentHttp({
                status: statusGetSolicitudPagoDirectoByID.status,
                statusText: statusGetSolicitudPagoDirectoByID.statusText
            });
        } else if (statusGetInfoSolicitudPagoDirecto?.status) {
            setCurrentHttp({
                status: statusGetInfoSolicitudPagoDirecto.status,
                statusText: statusGetInfoSolicitudPagoDirecto.statusText
            });
        } else if (statusGetSolicitudPagoDirectoByUser?.status) {
            setCurrentHttp({
                status: statusGetSolicitudPagoDirectoByUser.status,
                statusText: statusGetSolicitudPagoDirectoByUser.statusText
            });
        }
    }, [
        statusGetSolicitudPagoDirectoByID,
        statusGetInfoSolicitudPagoDirecto,
        statusGetSolicitudPagoDirectoByUser
    ]);

    ////////////////////////////////////////
    // Selección fila
    ////////////////////////////////////////
    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getSolicitudPagoDirectoByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    ////////////////////////////////////////
    // Generar formulario
    ////////////////////////////////////////
    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoSolicitudPagoDirecto(userId, expedienteIdByOrigen, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    ////////////////////////////////////////
    // Mostrar botón generar
    ////////////////////////////////////////
    useEffect(() => {
        const arrData = dataGetSolicitudPagoDirectoByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetSolicitudPagoDirectoByUser]);

    ////////////////////////////////////////
    // Loader unificado
    ////////////////////////////////////////
    const isLoading = () => {
        return (
            loadingGetSolicitudPagoDirectoByID ||
            loadingGetInfoSolicitudPagoDirecto ||
            (loadingGetSolicitudPagoDirectoByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetSolicitudPagoDirectoByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {/* SUCCESS */}
            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <SolicitudPagoDirecto
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getSolicitudPagoDirectoByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {/* ERROR */}
            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridSolicitudPagoDirecto;